import { type Module } from 'vuex';

import { store } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type InfoGroupsResult } from './types';

const INFO_GROUP_MODULE = 'infoGroup';

const infoGroupModuleInstance: Module<InfoGroupsResult, unknown> = {
    namespaced: true,
    state: {
        allInfoGroups: new Map()
    },
    actions,
    getters,
    mutations
};
store.registerModule(INFO_GROUP_MODULE, infoGroupModuleInstance);

export { INFO_GROUP_MODULE };
